const contractRoutes = ['duration', 'policyholder', 'policy-summary']

export const redirectionProvider = {
  redirectToFollowingStep: (currentStep: string) => {
    const currentStepIndex = contractRoutes.findIndex(
      (value, index) => value === currentStep,
    )
    if (currentStepIndex < 0) return '/contract'
    return `/contract/${contractRoutes[currentStepIndex + 1]}`
  },

  redirectToPreviousStep: (currentStep: string) => {
    const currentStepIndex = contractRoutes.findIndex(
      (value, index) => value === currentStep,
    )
    if (currentStepIndex === 0) return `/summary`
    const previousStepIndex = currentStepIndex - 1
    return `/contract/${contractRoutes[previousStepIndex]}`
  },

  redirectToStep: (step: number) => {
    if (step > contractRoutes.length || step <= 0) {
      return '/contract'
    }
    return `/contract/${contractRoutes[step - 1]}`
  },
}
